module.exports = __webpack_public_path__ + "91a323cc1e6ca9e4cfd290f09ec084bb.jpg";